export const EMPTY_STATE = 'emptyState';
export const FULL_STATE = 'fullState';
